<template>
  <div
    class="d3-layout-transparent mdl-layout mdl-js-layout mdl-layout--fixed-header mdl-layout--no-desktop-drawer-button">
    <header v-if="!isLineContentsMode" class="mdl-layout__header mdl-layout__header--scroll">
      <div class="mdl-layout__header-row">
        <div class="mdl-layout-spacer mdl-layout--small-screen-only"></div>

        <span class="mdl-layout-title">
          <router-link :to="{name: 'home'}">
            <img class="d3-header-logo" src="/static/img/dddisc-logo-header.png" alt="DDDisc ロゴ">
          </router-link>
        </span>
        <div class="mdl-layout-spacer"></div>
        <nav class="mdl-navigation mdl-layout--small-screen-only">
          <router-link class="d3-header-help mdl-navigation__link" :to="{name: 'support'}"><i class="material-icons">help_outline</i>
          </router-link>
        </nav>
        <nav class="mdl-navigation mdl-layout--large-screen-only">
          <button @click="onClickNavigation('requestFreeSample')"
                  class="mdl-button mdl-js-button mdl-button--raised mdl-button--primary mdl-js-ripple-effect-takei">
            {{$t("request.sample_title")}}
          </button>
          <router-link class="mdl-navigation__link" :to="{name: 'about'}">{{$t("nav.whats_dddisc")}}</router-link>
          <router-link class="mdl-navigation__link" :to="{name: 'solutions'}">{{$t("nav.solutions")}}</router-link>
          <router-link class="mdl-navigation__link" :to="{name: 'support'}">{{$t("help.title")}}</router-link>
          <router-link class="mdl-navigation__link" :to="{name: 'contact'}">{{$t("contact.title")}}</router-link>
          <router-link class="mdl-navigation__link" :to="{name: 'company'}">{{$t("company.title")}}</router-link>
        </nav>
      </div>
    </header>
    <div v-if="!isLineContentsMode" class="d3-drawer mdl-layout__drawer">
      <nav class="mdl-navigation">
        <a @click="onClickNavigation('home')" class="mdl-navigation__link">{{$t("nav.home")}}</a>
        <a @click="onClickNavigation('about')" class="mdl-navigation__link">{{$t("nav.whats_dddisc")}}</a>
        <a @click="onClickNavigation('support')" class="mdl-navigation__link">{{$t("help.title")}}</a>
        <a @click="onClickNavigation('termsOfService')" class="mdl-navigation__link">{{$t("tos.title")}}</a>
        <a @click="onClickNavigation('privacyPolicy')" class="mdl-navigation__link">{{$t("privacy.title")}}</a>
        <a @click="onClickNavigation('solutions')" class="mdl-navigation__link">{{$t("nav.solutions")}}</a>
        <a @click="onClickNavigation('showCase')" class="mdl-navigation__link">{{$t("nav.showcase")}}</a>
        <a @click="onClickNavigation('requestFreeSample')"
           class="mdl-navigation__link">{{$t("request.sample_title")}}</a>
        <a @click="onClickNavigation('contact')" class="mdl-navigation__link">{{$t("contact.title")}}</a>
        <a @click="onClickNavigation('company')" class="mdl-navigation__link">{{$t("company.title")}}</a>
      </nav>
      <div class="mdl-layout-spacer"></div>
      <button @click="onClickNavigation('scanInstruction')"
              class="d3-scan-button mdl-button mdl-js-button mdl-button--raised mdl-button--primary mdl-js-ripple-effect-takei">
        <img class="d3-scan-button-icon" src="/static/img/scan/dddisc-logo-white-square-70.png" alt="dddi.sc ディスクをスキャン">{{$t("nav.scan")}}
      </button>
    </div>

    <main id="main" class="mdl-layout__content">
      <router-view></router-view>
    </main>

    <snack-bar></snack-bar>
    <loading></loading>
    <flash></flash>
  </div>
</template>

<script>
  import store from '../store';
  import SnackBar from './util/SnackBar';
  import Loading from './util/Loading';
  import Flash from './util/Flash';
  import { mapGetters } from 'vuex';
  import { PLAY_CONTENT, INITIALIZE_DEVICE_INFO, INITIALIZE_COGNITO } from '../store/types';
  import userAgent from '../libs/user-agenet';

  export default {
    // Vuexのstoreをここで格納
    store,

    data(){
      return {};
    },

    computed: {
      ...mapGetters(['discData', 'cognitoIdentityId', 'browserName', 'deviceName', 'osName', 'mode']),

      isShowLoginButton(){
        return this.$route.name !== 'login';
      },

      isLineContentsMode(){
        return this.mode === 'line';
      }
    },

    /*methods: mapActions([
     types.LOGIN
     ]),*/
    methods: {
      /**
       * ドロワーのナビゲーションをクリックしたら遷移させる
       * router-linkにするとclickイベントが発火せずdrawerを閉じれないのでこういう実装になった
       * @param pageName
       */
      onClickNavigation(pageName){
        // 開いているドロワーを閉じる
        this.hideDrawer();

        if(pageName === 'onlineStore'){
          window.open('https://store.dddisc.com');
        }else{
          // ページ遷移する
          this.$router.push({name: pageName});
        }
      },

      /**
       * ドロワーを表示
       */
      showDrawer(){
        document.querySelector('.mdl-layout__obfuscator').classList.add('is-visible');
        document.querySelector('.mdl-layout__drawer').classList.add('is-visible');
      },

      /**
       * ドロワーを閉じる
       */
      hideDrawer(){
        document.querySelector('.mdl-layout__obfuscator').classList.remove('is-visible');
        document.querySelector('.mdl-layout__drawer').classList.remove('is-visible');
      },

      /**
       * URLにパラメータをつける
       */
      setUrlParameters(url, paramsArray){
        let resUrl = url.replace(/\?.*$/, '');
        for(let key in paramsArray){
          resUrl += (resUrl.indexOf('?') === -1) ? '?' : '&';
          resUrl += key + '=' + paramsArray[key];
        }
        return resUrl;
      },

      /**
       * コンテンツを表示する
       *
       * @param content
       * @param index
       */
      showContent({content, index, direct}){
        switch(content.dataType){
          case 'mp4':
          case 'mp3':
          case 'image':
          case 'dlc_code':
          case 'mp4_360':
            this.$router.push({name: 'content', params: {index: index}});
            break;

          case 'youtube':
          case 'questionnaire':
            // 再生ログ
            this.$store.dispatch(PLAY_CONTENT, {contentId: content.id});
            this.$router.push({name: 'content', params: {index: index}});
            break;

          case 'pdf':
            // iOSデバイスなら別タブで開く
            if(userAgent.isAppleDevice()){
              // 再生ログ
              this.$store.dispatch(PLAY_CONTENT, {contentId: content.id});
              window.open(content.data.pdfUrl, '_blank');
              if(direct){
                // 1コンテンツのみなので、1つ戻って認識ボタンの画面に
                this.$router.back();
              }
            }else{
              this.$router.push({name: 'content', params: {index: index}});
              this.$store.dispatch(PLAY_CONTENT, {contentId: content.id});
            }
            break;

          case 'url_link':
            if(content.data.s3Url){
              // クッキーつきリンクを開く
              let url = this.setUrlParameters(content.data.url, {
                contentType:  encodeURIComponent(content.data.contentType),
                contentUrl:   encodeURIComponent(content.data.s3Url),
                thumbnailUrl: encodeURIComponent(content.thumbnailUrl),
                title:        encodeURIComponent(content.name)
              });
              window.open(url, '_blank');
              if(direct){
                this.$router.back();
              }
              //this.$router.push({name: 'content', params: {index: index}});
            }else if(content.data.isInnerFrame){
              // 内部のiframeで開く
              this.$router.push({name: 'content', params: {index: index}});
            }else{
              // 再生ログ
              this.$store.dispatch(PLAY_CONTENT, {contentId: content.id});

              // 普通に別タブでURLを開く
              if(content.data.url){
                let url = content.data.url;

                // URのためにリンクにパラメータをつける
                if(this.discData && this.discData.projectId === 'a751f35a-7be4-4f01-83bd-4ab9f38ba76b'){
                  url = url + '?utm_source=dd&utm_medium=' + Number(this.discData.d3Code8);
                }

                if(content.data.conversionTagId){
                  // コンバージョンタグ用パラメータをURLにつける
                  // コンバージョンタグ用
                  console.log(this.discData);
                  let d3tag = btoa(JSON.stringify({
                    projectId:    this.discData.projectId,
                    cognitoId:    this.cognitoIdentityId,
                    orderId:      this.discData.orderId,
                    lotId:        this.discData.lotId,
                    discDataId:   this.discData.id,
                    hashedD3Code: this.discData.hashedD3Code,
                    contentId:    content.id
                  }));

                  url = this.setUrlParameters(content.data.url, {_d3tag: d3tag});
                }

                window.open(url, '_blank');
                if(direct){
                  this.$router.back();
                }
              }else{
                this.$root.$emit('show-snack-bar', 'URLが無効です。');
              }
            }
            break;

          // case 'app_link':

          default:
            this.$root.$emit('show-snack-bar', 'この形式には現在対応していません。');
            break;

        }
      }
    },

    created(){
      this.$store.dispatch(INITIALIZE_DEVICE_INFO);

      // 一度modeに触ってタイトルまわりをすぐに反映させる
      let mode = this.mode;
      if(mode === 'liff'){
        document.title = 'DDDisc for LINE';
      }

      // 有効期限がきたらすぐにクレデンシャル更新する
      let intervalId = null;
      store.watch((state)=>{
        return state.auth.tokenRemainTimeMs;
      }, (value)=>{
        // nullとかじゃないか調べる
        if(value){
          if(intervalId){
            window.clearInterval(intervalId);
          }

          intervalId = window.setInterval(()=>{
            logger('## Renew the credential');
            this.$store.dispatch(INITIALIZE_COGNITO);
          }, value);

          logger('Reset intervalID', value);
        }
      });

      // スナックバーの表示イベントを監視
      store.watch((state)=>{
        return state.d3.snackBarBody;
      }, (value)=>{
        this.$root.$emit('show-snack-bar', value.body);
      });

      // コンテンツ表示イベント監視
      this.$root.$on('show-content', this.showContent);
    },

    beforeDestroy(){
      // コンテンツ表示イベント解除
      this.$root.$off('show-content', this.showContent);
    },

    components: {
      SnackBar,
      Loading,
      Flash
    }
  };
</script>

<style lang="scss">
  /***************************************************************
   * ここのstyleはscopedじゃないので、グローバルなスタイルをここに定義
   ***************************************************************/
  @import "../global-variables";

  html, body {
    //overflow: hidden;
    overflow-x: hidden;
    height: 100%;
    width: 100%;

    background: $d3-white;

    font-family: 'RobotoRegular', 'Droid Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    /* iOS */
    //font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    /* Android */
    //font-family: 'RobotoRegular', 'Droid Sans', sans-serif;
    /* Windows Phone */
    //font-family: 'Segoe UI', Segoe, Tahoma, Geneva, sans-serif;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body.vjs-full-window .player_wrapper {
    position: static;
  }

  // ボタンや入力UIに青いアウトラインが表示されないようにする
  input[type="text"],
  input[type="password"],
  textarea,
  select {
    outline: none;
  }

  // ボタン系は選択できないようにするs
  .mdl-button {
    @include user-select-none();
  }

  a.mdl-button {
    box-sizing: border-box;
  }

  // トップの要素
  .d3-layout-transparent {
    header.mdl-layout__header {
      // ヘッダーの下に灰色の線を引く
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      background-color: rgba(255, 255, 255, 0.4);

      .d3-header-help {
        padding: 0;
        margin-left: 30px;
      }
    }

    .mdl-layout__drawer-button {
      // ドロワーボタンも選択不可に
      @include user-select-none();
    }

    // ヘッダー内のテキストは黒系で
    .mdl-layout__header,
    .mdl-navigation__link,
    .mdl-layout__header .mdl-layout__drawer-button {
      color: $text-black;
    }

    // ロゴの横幅
    .d3-header-logo {
      width: 130px;
    }

    // ドロワー
    .d3-drawer {
      .mdl-navigation__link {
        padding: 10px 16px;
      }

      .d3-scan-button {
        font-weight: bold;
        $scan-button-height: 50px;

        height: $scan-button-height;
        line-height: $scan-button-height;

        margin: 10px;

        .d3-scan-button-icon {
          width: 35px;
          margin-right: 8px;
        }
      }
    }

    // ログインボタン
    .d3-login-body-container {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;

      .d3-login-button {
        width: 100%;

        &.line {
          background: $line-color;
          color: white;
        }

        &.messenger {
          background: $messenger-color;
          color: white;
        }
      }

      .d3-back-button-container {
        margin: 0 auto;
      }
    }

    footer.d3-footer {
      .mdl-mega-footer__heading {
        font-size: 17px;
      }

      ul.mdl-mega-footer__link-list {
        padding-top: 8px;

        li {
          margin: 1px;
          padding: 8px;

          a {
            padding: 8px;
            font-size: 15px;
          }
        }
      }
    }
  }

  #main.mdl-layout__content {
    overflow: visible;

    .static-contents {
      @include user-select-initial();

      .static-contents-body {
        max-width: $text-page-ma-width;

        margin: 0 auto;
        padding: $text-page-margin;

        @media screen and (max-width: 450px) {
          padding: $text-page-margin-sp;
        }

        h4, h5, h6 {
          font-weight: bold;
        }
      }
    }
  }

  .nav-horizontal {
    overflow: hidden;
    height: 3em; /* 可視領域の高さ */
    width: 100%;
  }

  .nav-horizontal .mask {
    height: 5em; /* 横スクロールする理屈上の高さ */
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* 慣性スクロール */
  }

  .nav-horizontal .list {
    display: inline-table;
    max-width: 100%;
  }

  .nav-horizontal .list li {
    display: table-cell;
    font-size: 30px;
  }

  .vjs-big-play-button {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
  }

  .mdl-layout__container {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
</style>



// WEBPACK FOOTER //
// App.vue?05fb1ab5